import { KnownOrderHubDtoType, OrderHubDto } from '@groundfloor-platform/mgmt-service-g-sdk';

export function mapHubToDeliveryContainerLabel(hub?: OrderHubDto): string {
  if (!hub) return 'locker';

  switch (hub.type) {
    case KnownOrderHubDtoType.SpacesHub:
    case KnownOrderHubDtoType.KiosklessSpacesHub:
      return 'space';
    default:
      return 'locker';
  }
}
